(function () {
  if (window.__faqPageReady) return;
  window.__faqPageReady = true;

  var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function cancelAnim(panel) {
    if (!panel) return;
    var prev = panel._faqOnEnd;
    if (prev) {
      panel.removeEventListener('transitionend', prev);
      panel._faqOnEnd = null;
    }
    panel.style.transition = '';
    panel.style.height = '';
  }

  function closeItem(item, instant) {
    item.classList.remove('is-open');
    var btn = item.querySelector('[data-faq-trigger]');
    var panel = item.querySelector('[data-faq-panel]');
    if (btn) btn.setAttribute('aria-expanded', 'false');
    if (!panel) return;
    cancelAnim(panel);
    if (panel.hidden) return;
    if (prefersReduced || instant) {
      panel.hidden = true;
      panel.style.height = '';
      return;
    }
    var startH = panel.getBoundingClientRect().height;
    panel.style.height = startH + 'px';
    requestAnimationFrame(function () {
      panel.style.transition = 'height 220ms ease';
      panel.style.height = '0px';
    });
    var onEnd = function (event) {
      if (event.propertyName !== 'height') return;
      panel.hidden = true;
      panel.style.height = '';
      panel.style.transition = '';
      panel.removeEventListener('transitionend', onEnd);
      panel._faqOnEnd = null;
    };
    panel._faqOnEnd = onEnd;
    panel.addEventListener('transitionend', onEnd);
  }

  function openItem(item, instant) {
    item.classList.add('is-open');
    var btn = item.querySelector('[data-faq-trigger]');
    var panel = item.querySelector('[data-faq-panel]');
    if (btn) btn.setAttribute('aria-expanded', 'true');
    if (!panel) return;
    cancelAnim(panel);
    panel.hidden = false;
    var inner = panel.firstElementChild;
    if (!inner) return;
    if (prefersReduced || instant) {
      panel.style.height = '';
      return;
    }
    panel.style.height = '0px';
    requestAnimationFrame(function () {
      panel.style.transition = 'height 240ms ease';
      panel.style.height = inner.scrollHeight + 'px';
    });
    var onEnd = function (event) {
      if (event.propertyName !== 'height') return;
      panel.style.height = '';
      panel.style.transition = '';
      panel.removeEventListener('transitionend', onEnd);
      panel._faqOnEnd = null;
    };
    panel._faqOnEnd = onEnd;
    panel.addEventListener('transitionend', onEnd);
  }

  function initAccordion(root) {
    root.querySelectorAll('[data-faq-list]').forEach(function (list) {
      if (list.dataset.faqListInitialized === 'true') return;

      var items = Array.from(list.querySelectorAll('[data-faq-item]'));
      if (!items.length) return;
      list.dataset.faqListInitialized = 'true';

      items.forEach(function (item) {
        var btn = item.querySelector('[data-faq-trigger]');
        if (!btn) return;
        btn.addEventListener('click', function () {
          var isOpen = item.classList.contains('is-open');
          items.forEach(function (other) {
            if (other !== item) closeItem(other);
          });
          if (isOpen) closeItem(item);
          else openItem(item);
        });
      });

      var defaultOpen = items.find(function (item) {
        return item.hasAttribute('data-open-default');
      });
      if (defaultOpen) {
        items.forEach(function (item) {
          if (item !== defaultOpen) {
            item.classList.remove('is-open');
            var panel = item.querySelector('[data-faq-panel]');
            var btn = item.querySelector('[data-faq-trigger]');
            if (btn) btn.setAttribute('aria-expanded', 'false');
            if (panel) {
              cancelAnim(panel);
              panel.hidden = true;
            }
          }
        });
        var openPanel = defaultOpen.querySelector('[data-faq-panel]');
        var openBtn = defaultOpen.querySelector('[data-faq-trigger]');
        if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
        if (openPanel) {
          cancelAnim(openPanel);
          openPanel.hidden = false;
          openPanel.style.height = '';
        }
      } else {
        items.forEach(function (item) {
          var panel = item.querySelector('[data-faq-panel]');
          var btn = item.querySelector('[data-faq-trigger]');
          var opened = item.classList.contains('is-open');
          if (btn) btn.setAttribute('aria-expanded', opened ? 'true' : 'false');
          if (panel) {
            cancelAnim(panel);
            panel.hidden = !opened;
          }
        });
      }
    });
  }

  function getHeaderOffset() {
    var header = document.querySelector('.shopify-section-header');
    return header ? header.offsetHeight : 0;
  }

  function init(root) {
    if (!root || root.dataset.faqPageInitialized === 'true') return;
    root.dataset.faqPageInitialized = 'true';

    initAccordion(root);

    var tabs = Array.from(root.querySelectorAll('[data-faqp-tab]'));
    var cats = Array.from(root.querySelectorAll('[data-faqp-cat]'));
    if (!tabs.length || !cats.length) return;

    var isClickScrolling = false;

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function (event) {
        event.preventDefault();
        var idx = tab.getAttribute('data-faqp-tab');
        var target = root.querySelector('[data-faqp-cat="' + idx + '"]');
        if (target) {
          isClickScrolling = true;
          var y = target.getBoundingClientRect().top + window.scrollY - getHeaderOffset() - 16;
          window.scrollTo({ top: y, behavior: 'smooth' });
          clearTimeout(root._scrollTimer);
          root._scrollTimer = setTimeout(function () {
            isClickScrolling = false;
          }, 800);
        }
        tabs.forEach(function (item) {
          item.classList.remove('is-active');
        });
        tab.classList.add('is-active');
      });
    });

    var observer = new IntersectionObserver(function (entries) {
      if (isClickScrolling) return;
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var idx = entry.target.getAttribute('data-faqp-cat');
        tabs.forEach(function (tab) {
          tab.classList.toggle('is-active', tab.getAttribute('data-faqp-tab') === idx);
        });
        var activeTab = tabs.find(function (tab) {
          return tab.getAttribute('data-faqp-tab') === idx;
        });
        if (activeTab) {
          var nav = root.querySelector('.faqp__tabs');
          if (nav) {
            var navRect = nav.getBoundingClientRect();
            var tabRect = activeTab.getBoundingClientRect();
            var scrollLeft = nav.scrollLeft + (tabRect.left - navRect.left) - navRect.width / 2 + tabRect.width / 2;
            nav.scrollTo({ left: scrollLeft, behavior: 'smooth' });
          }
        }
      });
    }, { rootMargin: '-20% 0px -60% 0px', threshold: 0 });

    cats.forEach(function (cat) {
      observer.observe(cat);
    });

    function scrollToTarget(target) {
      var y = target.getBoundingClientRect().top + window.scrollY - getHeaderOffset() - 24;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }

    function handleHash() {
      var hash = window.location.hash.replace('#', '');
      if (!hash) return;
      var target = document.getElementById(hash);
      if (!target || !target.hasAttribute('data-faq-item')) return;

      var list = target.closest('[data-faq-list]');
      if (list) {
        Array.from(list.querySelectorAll('[data-faq-item]')).forEach(function (item) {
          if (item !== target) closeItem(item, true);
        });
      }
      openItem(target, true);

      requestAnimationFrame(function () {
        window.scrollTo({ top: 0, behavior: 'instant' });
        requestAnimationFrame(function () {
          scrollToTarget(target);
        });
      });
    }

    if (window.location.hash) {
      history.scrollRestoration = 'manual';
      window.scrollTo({ top: 0, behavior: 'instant' });
      setTimeout(handleHash, 300);
    }

    window.addEventListener('hashchange', handleHash);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-faq-page]').forEach(init);
  }

  initAll();
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
